module.exports = __webpack_public_path__ + "img/dify-logo.4a050297.svg";